<dt-modal-content [showFooter]="state === 'start'" (closeClick)="tryClose()" [showX]="canClose">
  <ng-template #title i18n>Projekt als PDF exportieren</ng-template>

  <ng-template #content>
    @if (state === 'start') {
      <h4 i18n>Projektdaten</h4>
      <mat-form-field>
        <mat-label i18n>Projekttitel</mat-label>
        <input matInput [(ngModel)]="projectTitle" type="text" />
      </mat-form-field>
      <mat-form-field>
        <mat-label i18n>Datum</mat-label>
        <input matInput [matDatepicker]="datePicker" [(ngModel)]="date" type="text" />
        <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
        <mat-datepicker #datePicker></mat-datepicker>
      </mat-form-field>
      <mat-form-field>
        <mat-label i18n>Name des Autors</mat-label>
        <input matInput [(ngModel)]="author" type="text" />
      </mat-form-field>
      <h4 i18n>Detailgrad des Reports</h4>
      <mat-radio-group [(ngModel)]="reportType">
        <mat-radio-button [value]="0"
          ><span class="radio-content" i18n
            >Kurz: Enthält nur die Projektstruktur. Dies umfasst allgemeine Projektinformationen, die Entscheidungsfrage, Ziele,
            Alternativen und Einflussfaktoren.</span
          ></mat-radio-button
        >
        <mat-radio-button [value]="1"
          ><span class="radio-content" i18n
            >Vollständig: Enthält darüber hinaus auch Wirkungsprognosen sowie Nutzenfunktionen, Zielgewichtung und das Ergebnis eines
            Robustheitstests.</span
          ></mat-radio-button
        >
      </mat-radio-group>
      @if (noWorker && reportType === 1) {
        <span i18n
          >Leider kann Dein Browser nicht zur Berechnung des Robustheitstests verwendet werden. Bitte nutze einen
          <a href="https://caniuse.com/#feat=webworkers">aktuelleren Browser</a>.</span
        >
      }
    }

    @if (state === 'performingRc') {
      <div class="rc-progress">
        <mat-progress-bar mode="determinate" [value]="rcProgress * 100"></mat-progress-bar>
        <p i18n>Berechne Robustheitstest ({{ rcProgress | percent }})</p>
      </div>
    }

    @if (state === 'processing') {
      <div class="rc-progress">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        <p i18n>Verarbeite…</p>
      </div>
    }

    @if (state === 'done') {
      <div class="pdf-button-container">
        <button mat-raised-button color="accent-less" (click)="pdfDoc.open()" i18n
          >PDF-Datei öffnen (Funktioniert nicht in jedem Browser)</button
        >
        <button mat-raised-button color="accent" (click)="pdfDoc.download(projectTitle + '.pdf')" i18n data-cy="download-pdf-button"
          >PDF-Datei herunterladen</button
        >
      </div>
    }
  </ng-template>

  <ng-template #footer>
    <button mat-raised-button color="accent" (click)="submit()" i18n data-cy="generate-pdf-button">PDF generieren</button>
  </ng-template>
</dt-modal-content>
